module.exports = __webpack_public_path__ + "static/terravitis-66440ee1559329fc1f5bc828d440b776.png";